// We need to import the CSS so that webpack will load it.
// The MiniCssExtractPlugin is used to separate it out into
// its own CSS file.
import "../css/app.scss";

// webpack automatically bundles all modules in your
// entry points. Those entry points can be configured
// in "webpack.config.js".
//
// Import deps with the dep name or local files with a relative path, for example:
//
import "regenerator-runtime/runtime";
import "phoenix_html";
import "whatwg-fetch";
import "materialize-css";
import "preact/debug"; // <-- Add this line at the top of your main entry file
// Materialize 3 icons
import "material-symbols";

// import createTrackingSocketTransport from "./tracking/trackingSocket";
import "./liveSocket";

import * as errors from "./errors";
import initAlternatingCards from "./oldSchool/initAlternatingCards";
import initCarousel from "./oldSchool/initCarousel";
import initClearableFlashes from "./oldSchool/initClearableFlashes";
import initCollapsibles from "./oldSchool/initCollapsibles";
import initDataSubmit from "./oldSchool/initDataSubmit";
import initDomTracking from "./oldSchool/initDomTracking";
import initDropdownInputColor from "./oldSchool/initDropdownInputColor";
import initInputFields from "./oldSchool/initInputFields";
import initLightbox from "./oldSchool/initLightbox";
import initMaterializeCss from "./oldSchool/initMaterializeCss";
import initModal from "./oldSchool/initModal";
import initNaviDrawer from "./oldSchool/initNaviDrawer";
import initPlaintextPasswordToggle from "./oldSchool/initPlaintextPasswordToggle";
import initReactApp from "./oldSchool/initReactApp";
import initRedactions from "./oldSchool/initRedactions";
import initRevealOnView from "./oldSchool/initRevealOnView";
import initScrollStateClass from "./oldSchool/initScrollStateClass";
import initShareButton from "./oldSchool/initShareButton";
import initStickybox from "./oldSchool/initStickybox";
import initTooltips from "./oldSchool/initTooltips";
import initWidgets from "./oldSchool/initWidgets";

errors.initialize();

/**
 * Our new way of initializing components. Maybe it interferes less with
 * page loading.
 *
 * @example init("lightbox", "product-image-modal")
 */
const INITIATORS = {
  carousel: initCarousel,
  lightbox: initLightbox,
  modal: initModal,
  shareButton: initShareButton,
  stickybox: initStickybox,
  redactions: initRedactions,
};

document.addEventListener("DOMContentLoaded", async function () {
  initMaterializeCss();

  initDomTracking();
  initScrollStateClass();

  initCollapsibles();
  initReactApp();
  initDataSubmit();

  initWidgets();

  initNaviDrawer();

  initPlaintextPasswordToggle();
  initClearableFlashes();

  initDropdownInputColor();

  initAlternatingCards("person-card");
  initAlternatingCards("person-card-below");

  initInputFields();
  initTooltips();

  window.inits.forEach(([key, ...args]) => {
    INITIATORS[key](...args);
  });

  initRevealOnView();
});
